import { render, staticRenderFns } from "./developHistory.vue?vue&type=template&id=3a57d9e4&scoped=true&"
import script from "./developHistory.vue?vue&type=script&lang=js&"
export * from "./developHistory.vue?vue&type=script&lang=js&"
import style0 from "./developHistory.vue?vue&type=style&index=0&id=3a57d9e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a57d9e4",
  null
  
)

export default component.exports